import {isNullOrUndefined} from './is-null-or-undefined';

export function isNullOrUndefinedOrEmpty(value) {
  return (isNullOrUndefined(value) || (value === ''));
}



// WEBPACK FOOTER //
// ./src/app/services/utils/is-null-or-undefined-or-empty.ts